<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/deal/list" color="blue">取消回上一頁</v-btn>
    </div>

    <v-form @submit.prevent="submit()" v-model="valid">
      <v-card flat tile class="mb-6">
        <v-card-text>
          <p class="title mb-6">新增活動</p>

            <v-text-field
              v-model="form.active_name"
              :rules="[formRules.required]"
              :persistent-hint="true"
              label="活動名稱"
              outlined
            ></v-text-field>

            <v-text-field
              type="text"
              v-model.active_code="form.active_code"
              :rules="[formRules.required]"
              hint="請輸入不重複的代碼，如序號為亂數取出，會加入次代碼在序號中"
              label="活動代碼"
              outlined
            ></v-text-field>
            <br>


            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.start_time"
                  label="開始時間"
                  :rules="[formRules.required]"
                  readonly
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.start_time" locale="zh-cn" color="blue"></v-date-picker>
            </v-menu>

            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.end_time"
                  label="結束時間"
                  :rules="[formRules.required]"
                  readonly
                  v-on="on"
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.end_time" locale="zh-cn" color="blue"></v-date-picker>
            </v-menu>


            <v-select
              v-model="form.available"
              :items="mappingAvailable"
              item-text="text"
              item-value="value"
              placeholder="啟用狀態"
              outlined
            ></v-select>
        </v-card-text>
      </v-card>

      <div class="text-center mb-6">
        <v-btn to="/deal/list" color="blue" class="mr-3">取消回上一頁</v-btn>
        <v-btn type="submit" :disabled="!valid" color="orange">確認新增</v-btn>
      </div>
    </v-form>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import DataMixin from "@/mixins/Data";

import activesApi from "@/api/actives";

export default {
  components: {},

  mixins: [DataMixin],

  props: [],
  data() {
    return {
      valid: false,

      form: {
        active_name: "",
        active_code: "",
        start_time: "",
        end_time: "",
        available: true
      }
    };
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    submit() {
      activesApi
        .create(this.form)
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });
          } else {
            this.$router.push("/active/list");
          }
        })
        .catch(err => {});
    }
  },

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
